<template>
  <div>
    <signature-layout
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="subtitle">
        Registration Application
      </span>
      <span slot="title">Individual Dog Registration - Kennel Name Usage Agreement</span>
      <div slot="approvedContent" v-if="registration && registration.requestId">
        <DogRegistrationIndividualRequest :registration="registration" />
      </div>
      <div slot="legalText">
        <p class="bottom-text">
          Upon signing, I testify that all data submitted is correct.
        I understand that all applications become the property of ASCA.
        If an application has been falsified, no registration certificate will be issued and fees will not be refunded.
        I hereby certify that this dog has not been registered as another breed.
        In addition, I will not register this dog as another breed.
        I understand if I register this dog as another breed its ASCA registration will be revoked.
        Should information in this application prove false, applicant will indemnify and defend ASCA and hold it harmless against any resulting loss.
        The lineage of your dog can be determined, with certainty, by DNA testing sponsored by ASCA.
        I further understand that as owner of an ASCA registered dog, I agree to abide by the <ASCAArtIncLink />, <BylawsLink />, rules of the ASCA Registries and all event programs, and to disciplinary action, if necessary, as determined by the Board of Directors of ASCA.
        </p>
      </div>
    </signature-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import SignatureLayout from "@/components/common/SignatureLayout.vue";
import DogRegistrationIndividualRequest from "@/components/Portal/MyRequest/DogRegistrationIndividualRequest.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";

export default Vue.extend({
  name: "DogRegistrationIndividualKennelNameUsageSignature",
  components: {
    SignatureLayout,
    DogRegistrationIndividualRequest,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
      rulesDialog: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    toggleRules() { this.$data.rulesDialog = !this.$data.rulesDialog; },
    load: async function () {
      this.isLoading = true;

      const response = await workflowService.getDogRegistrationIndividualKennelNameUsageSignatureRequest(this.signatureId);

      this.errorMessage = "";
      this.found = response.found;

      if (response.found && (!response.errors || response.errors.length == 0)) {
        this.registration = response.data;
      } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'

      this.isLoading = false;
    },
    sign: function (workflowGuid: String, signatureId: number, personId: number, text: String) {
      workflowService
        .signDogRegistrationIndividualKennelNameUsage(workflowGuid, signatureId, personId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
          this.$router.push("/");
        }).catch(this.$handleError);
    },
  },
});
</script>
